import React from 'react';
import { CheckIcon } from '@prisjakt/ui-icons';
import { BodySmallText, CaptionText } from '@prisjakt/ui/text/variants';
import { CheckboxOption, Checkbox as StyledCheckbox } from '../styles';

const FilterOption: React.FC<IFilterOptionProps> = props => {
  const { name, defaultValue, onFilterChangedHandler, label, caption } = props;

  const onChangeHandler = () => {
    const newVal = !defaultValue;
    onFilterChangedHandler(name, newVal);
  };

  return (
    <div>
      <BodySmallText>
        <CheckboxOption onClick={onChangeHandler}>
          <StyledCheckbox checked={defaultValue}>
            <CheckIcon
              styling="neutral-light"
              strokeWidth="6"
              height={14}
              left={1}
              top={1}
              checked={defaultValue}
            />
          </StyledCheckbox>
          {label}
        </CheckboxOption>
      </BodySmallText>
      <CaptionText>{caption}</CaptionText>
    </div>
  );
};

interface IFilterOptionProps {
  name: string;
  defaultValue: boolean;
  label?: string;
  caption?: string;
  onFilterChangedHandler: (name: string, val: boolean) => void;
}

export default FilterOption;
